import { UserDto, SmeSignupDto, BusinessUserApi, OrganisationAssignmentDto } from 'models/dtoTypes';
import { API_URL } from 'kosmosConfig';
import { Configuration } from 'models/generated';
import { CurrentUser } from 'auth';

const getBusinessUserClient = () => {
  const locale = CurrentUser.getInstance().getLocale() || 'en-GB';
  const config = new Configuration({
    basePath: API_URL.replace(/\/+$/, ''),
    baseOptions: {
      headers: {
        'Accept-Language': locale,
      },
    },
  });
  return new BusinessUserApi(config);
};

export const SmeSignup = async (requestBody: SmeSignupDto): Promise<UserDto> => {
  const client = getBusinessUserClient();
  const response = await client.smeSelfSignup(requestBody);
  return response.data;
};

export const ValidateSMEInvitationToken = async (
  token: string,
): Promise<OrganisationAssignmentDto> => {
  const client = getBusinessUserClient();
  const response = await client.validateSMEInvitationToken(token);
  return response.data;
};

export const GetLogoByOrganisationId = async (orgId: string): Promise<string> => {
  const client = getBusinessUserClient();
  const response = await client.getLogoByOrganisationId(orgId);
  return response.data;
};
